// SEO Data - Extended Version with 2000+ links
// Locations, Services, Materials for maximum SEO coverage

// ============================================
// LOCATIONS - All cities and villages (400+)
// ============================================
export const locations = {
  bratislava: {
    name: "Bratislava",
    districts: [
      "Staré Mesto", "Ružinov", "Nové Mesto", "Karlova Ves", "Dúbravka",
      "Petržalka", "Lamač", "Devín", "Devínska Nová Ves", "Záhorská Bystrica",
      "Rača", "Vajnory", "Podunajské Biskupice", "Vrakuňa", "Čunovo",
      "Rusovce", "Jarovce"
    ]
  },
  senec: {
    name: "Okres Senec",
    cities: [
      "Senec", "Bernolákovo", "Ivanka pri Dunaji", "Chorvátsky Grob",
      "Slovenský Grob", "Viničné", "Vinosady", "Kráľová pri Senci",
      "Hrubá Borša", "Hrubý Šúr", "Igram", "Malinovo", "Most pri Bratislave",
      "Nová Dedinka", "Reca", "Tomášov", "Tureň", "Veľký Biel", "Vlky",
      "Blatné", "Kostolná pri Dunaji", "Hamuliakovo", "Kalinkovo",
      "Boldog", "Čataj", "Dunajská Lužná", "Miloslavov", "Rovinka",
      "Hurbanova Ves", "Kaplna", "Nový Svet", "Pusté Úľany", "Veľká Paka"
    ]
  },
  pezinok: {
    name: "Okres Pezinok",
    cities: [
      "Pezinok", "Modra", "Svätý Jur", "Vinosady", "Viničné",
      "Slovenský Grob", "Chorvátsky Grob", "Limbach", "Šenkvice",
      "Častá", "Doľany", "Budmerice", "Báhoň", "Dubová", "Jablonec",
      "Píla", "Vištuk", "Cajla", "Grinava", "Myslenice", "Štefanová"
    ]
  },
  trnava: {
    name: "Okres Trnava",
    cities: [
      "Trnava", "Zeleneč", "Biely Kostol", "Bíňovce", "Boleráz",
      "Bohdanovce nad Trnavou", "Brestovany", "Buková", "Cífer",
      "Červeník", "Dechtice", "Dlhá", "Dolné Lovčice", "Dolné Orešany",
      "Doľany", "Hrnčiarovce nad Parnou", "Horné Orešany", "Kátlovce",
      "Križovany nad Dudváhom", "Malženice", "Majcichov", "Naháč",
      "Opoj", "Pavlice", "Ružindol", "Smolenice", "Suchá nad Parnou",
      "Šelpice", "Šúrovce", "Trstín", "Voderady", "Zavar", "Zvončín",
      "Abrahamovce", "Bučany", "Dolná Krupá", "Horná Krupá", "Jaslovské Bohunice",
      "Koplotovce", "Lošonec", "Modranka", "Radošovce", "Špačince"
    ]
  },
  dunajskaStreda: {
    name: "Okres Dunajská Streda",
    cities: [
      "Dunajská Streda", "Šamorín", "Gabčíkovo", "Veľký Meder",
      "Čilistov", "Rohovce", "Kostolné Kračany", "Štvrtok na Ostrove",
      "Dolný Štál", "Horný Štál", "Kyselica", "Malé Dvorníky",
      "Veľké Dvorníky", "Bodíky", "Báč", "Baka", "Blahová", "Blatná na Ostrove",
      "Čakany", "Čenkovce", "Dolný Bar", "Holice", "Horné Mýto",
      "Hubice", "Janíky", "Jurová", "Kľúčovec", "Kráľovičove Kračany",
      "Kvetoslavov", "Lúč na Ostrove", "Mad", "Mierovo", "Michal na Ostrove",
      "Novosad", "Nový Život", "Ohrady", "Okoč", "Oľdza", "Padáň",
      "Pataš", "Povoda", "Sap", "Trhová Hradská", "Trnávka",
      "Veľká Paka", "Vieska", "Vojka nad Dunajom", "Vrakúň", "Vydrany",
      "Lehnice", "Ňárad", "Topoľníky", "Veľké Blahovo", "Zlaté Klasy"
    ]
  },
  galanta: {
    name: "Okres Galanta",
    cities: [
      "Galanta", "Sereď", "Sládkovičovo", "Dolná Streda", "Horné Saliby",
      "Dolné Saliby", "Kajal", "Kráľov Brod", "Mostová", "Nebojsa",
      "Pata", "Pusté Sady", "Tomášikovo", "Topoľníky", "Trstice",
      "Váhovce", "Veľká Mača", "Veľké Úľany", "Vinohrady nad Váhom",
      "Vlčany", "Vozokany", "Čierny Brod", "Čierna Voda", "Jelka",
      "Jánovce", "Košúty", "Malá Mača", "Abrahám", "Gáň", "Hodruša",
      "Horná Streda", "Hrušovany", "Javorinka", "Košolná", "Matúškovo"
    ]
  },
  malacky: {
    name: "Okres Malacky",
    cities: [
      "Malacky", "Stupava", "Lozorno", "Zohor", "Záhorská Ves",
      "Vysoká pri Morave", "Suchohrad", "Rohožník", "Pernek",
      "Plavecký Štvrtok", "Plavecký Mikuláš", "Plavecké Podhradie",
      "Lakšárska Nová Ves", "Kuchyňa", "Kostolište", "Jablonové",
      "Gajary", "Jakubov", "Veľké Leváre", "Závod", "Borinka",
      "Marianka", "Studienka", "Sološnica", "Plavecký Peter",
      "Riadok", "Sekule", "Štefanov", "Záhorská Bystrica"
    ]
  },
  komarno: {
    name: "Okres Komárno",
    cities: [
      "Komárno", "Hurbanovo", "Kolárovo", "Zlatná na Ostrove",
      "Pribeta", "Moča", "Marcelová", "Martovce", "Mudroňovo",
      "Nesvady", "Okoličná na Ostrove", "Patince", "Svätý Peter",
      "Trávnik", "Vrbová nad Váhom", "Zemné", "Čalovec", "Číčov",
      "Dulovce", "Holiare", "Chotín", "Imeľ", "Iža", "Kameničná",
      "Bajč", "Bodza", "Brestovec", "Búč", "Klížska Nemá", "Kravany nad Dunajom",
      "Lipové", "Malá Kesa", "Nová Stráž", "Sokolce", "Svätý Ján", "Tôň",
      "Veľké Kosihy", "Virt", "Zemianska Olča"
    ]
  },
  noveZamky: {
    name: "Okres Nové Zámky",
    cities: [
      "Nové Zámky", "Štúrovo", "Šurany", "Dvory nad Žitavou", "Palárikovo",
      "Tvrdošovce", "Komjatice", "Semerovo", "Jasová", "Bánov",
      "Bardoňovo", "Bešeňov", "Bruty", "Čechy", "Dubník", "Gbelce",
      "Hul", "Chľaba", "Jatov", "Kamenica nad Hronom", "Kamenín",
      "Kolta", "Komoča", "Lipová", "Malá nad Hronom", "Malé Kosihy",
      "Mužla", "Nána", "Nová Vieska", "Obid", "Pavlová", "Pozba",
      "Rastislavice", "Rúbaň", "Salka", "Strekov", "Svodín", "Trávnica",
      "Veľká Dolina", "Zemné", "Radava", "Sikenička", "Belá", "Mojzesovo"
    ]
  },
  levice: {
    name: "Okres Levice",
    cities: [
      "Levice", "Želiezovce", "Tlmače", "Šahy", "Pukanec", "Kalná nad Hronom",
      "Čaka", "Farná", "Horná Seč", "Horné Turovce", "Hronovce",
      "Ipeľské Úľany", "Jur nad Hronom", "Keť", "Kozárovce", "Krškany",
      "Málaš", "Mýtne Ludany", "Nová Dedina", "Nový Tekov", "Ondrejovce",
      "Plavé Vozokany", "Pohronský Ruskov", "Rybnky", "Santovka",
      "Slatina", "Starý Hrádok", "Starý Tekov", "Tekovské Lužany",
      "Uhliská", "Veľký Ďur", "Zbrojníky", "Beša", "Čajkov"
    ]
  },
  sala: {
    name: "Okres Šaľa",
    cities: [
      "Šaľa", "Močenok", "Vlčany", "Diakovce", "Hájske", "Kráľová nad Váhom",
      "Neded", "Selice", "Tešedíkovo", "Trnovec nad Váhom", "Žihárec",
      "Dlhá nad Váhom", "Horná Kráľová"
    ]
  },
  hlohovec: {
    name: "Okres Hlohovec",
    cities: [
      "Hlohovec", "Leopoldov", "Bojničky", "Dolné Trhovište", "Dolné Zelenice",
      "Horné Trhovište", "Horné Zelenice", "Jalšové", "Kľačany", "Koplotovce",
      "Madunice", "Pastuchov", "Sasinkovo", "Siladice", "Tekolďany", "Tepličky"
    ]
  },
  piestany: {
    name: "Okres Piešťany",
    cities: [
      "Piešťany", "Vrbové", "Moravany nad Váhom", "Banka", "Borovce",
      "Drahovce", "Ducové", "Hubina", "Chtelnica", "Kočín", "Krakovany",
      "Lančár", "Ostrov", "Pečeňady", "Rakovice", "Ratnovce", "Sokolovce",
      "Šípkové", "Trebatice", "Veľké Kostoľany", "Veselé", "Výčapy-Opatovce"
    ]
  },
  senica: {
    name: "Okres Senica",
    cities: [
      "Senica", "Holíč", "Skalica", "Gbely", "Borský Svätý Jur",
      "Borský Mikuláš", "Brodské", "Čáčov", "Častkov", "Cerová",
      "Dojč", "Dubovce", "Hlboké", "Hradište pod Vrátnom", "Jablonica",
      "Koválov", "Kunov", "Kuklov", "Lakšárska Nová Ves", "Letničie",
      "Lopašov", "Mokrý Háj", "Osuské", "Petrova Ves", "Podbranč",
      "Popudinské Močidľany", "Prietrž", "Radimov", "Radošovce",
      "Rovensko", "Smolinské", "Sobotište", "Šajdíkove Humence",
      "Štefanov", "Trnovec", "Unín", "Vrádište"
    ]
  },
  nitra: {
    name: "Okres Nitra",
    cities: [
      "Nitra", "Vráble", "Čechynce", "Čifáre", "Dolné Obdokovce",
      "Golianovo", "Horné Lefantovce", "Hruboňovo", "Ivanka pri Nitre",
      "Janíkovce", "Jelšovce", "Jelenec", "Kapince", "Kolíňany",
      "Lehota", "Lužianky", "Malý Lapáš", "Mojmírovce", "Nitrianske Hrnčiarovce",
      "Nové Sady", "Paňa", "Pohranice", "Podhorany", "Rišňovce",
      "Rumanová", "Štitáre", "Tajná", "Telince", "Veľká Dolina",
      "Veľký Cetín", "Veľký Lapáš", "Vinodol", "Výčapy-Opatovce",
      "Zbehy", "Zobor", "Branč", "Čab", "Dolné Lefantovce"
    ]
  },
  zlateMoravce: {
    name: "Okres Zlaté Moravce",
    cities: [
      "Zlaté Moravce", "Topoľčianky", "Hostie", "Choča", "Ladice",
      "Machulince", "Mankovce", "Martin nad Žitavou", "Neverice",
      "Nevidzany", "Obyce", "Sľažany", "Tekovské Nemce", "Tesárske Mlyňany",
      "Velušovce", "Vieska nad Žitavou", "Volkovce", "Žikava", "Žitavce"
    ]
  }
};

// ============================================
// SERVICES - Extended (50+ services)
// ============================================
export const services = {
  hlavne: [
    { slug: "stavby-na-kluc", name: "Stavby na kľúč", keywords: ["výstavba domu", "novostavba", "rodinný dom", "dom na kľúč"] },
    { slug: "holodomy", name: "Holodomy", keywords: ["hrubá stavba", "holodom", "dom na dokončenie", "shell house"] },
    { slug: "rekonstrukcie", name: "Rekonštrukcie", keywords: ["prestavba", "modernizácia", "obnova", "rekonštrukcia bytu"] },
    { slug: "zateplenie", name: "Zateplenie", keywords: ["izolácia", "fasáda", "tepelná izolácia", "ETICS"] },
    { slug: "zamkova-dlazba", name: "Zámková dlažba", keywords: ["dlažba", "chodník", "príjazdová cesta", "terasa"] },
    { slug: "bazeny", name: "Bazény", keywords: ["stavba bazéna", "záhradný bazén", "kúpacie jazierko", "infinity bazén"] }
  ],
  stavebne: [
    { slug: "zaklady", name: "Základy domu", keywords: ["základová doska", "výkopy", "betónové základy"] },
    { slug: "murovanie", name: "Murárske práce", keywords: ["murovanie", "tehla", "tvárnice", "murovacie práce"] },
    { slug: "betonovanie", name: "Betónovanie", keywords: ["betón", "betónová zmes", "monolitické konštrukcie"] },
    { slug: "zelezobeton", name: "Železobetón", keywords: ["armatúra", "výstuž", "železobetónové konštrukcie"] },
    { slug: "priecky", name: "Priečky", keywords: ["deliace priečky", "SDK priečky", "murované priečky"] },
    { slug: "nadstavby", name: "Nadstavby", keywords: ["nadstavba domu", "prístavba", "rozšírenie domu"] },
    { slug: "demolacie", name: "Demolácie", keywords: ["búranie", "odvoz sutiny", "likvidácia", "demolačné práce"] },
    { slug: "zemne-prace", name: "Zemné práce", keywords: ["výkopy", "navážka", "terénne úpravy", "bagrovanie"] }
  ],
  strechy: [
    { slug: "strechy", name: "Strechy", keywords: ["strešná krytina", "krov", "zateplenie strechy"] },
    { slug: "krov", name: "Krovové konštrukcie", keywords: ["krov", "drevená konštrukcia", "väzníkový krov"] },
    { slug: "stresna-krytina", name: "Strešná krytina", keywords: ["škridla", "plech", "šindle"] },
    { slug: "klampiarstvo", name: "Klampiarske práce", keywords: ["odkvap", "zvod", "oplechovanie", "lemovanie"] },
    { slug: "zateplenie-strechy", name: "Zateplenie strechy", keywords: ["podkrovie", "minerálna vata", "PIR"] },
    { slug: "plocha-strecha", name: "Plochá strecha", keywords: ["EPDM", "asfaltové pásy", "hydroizolácia"] },
    { slug: "zelena-strecha", name: "Zelená strecha", keywords: ["vegetačná strecha", "extenzívna", "intenzívna"] },
    { slug: "vikiere", name: "Vikiere a strešné okná", keywords: ["vikier", "strešné okno", "Velux"] }
  ],
  interier: [
    { slug: "sadrokarton", name: "Sadrokartón", keywords: ["SDK", "priečky", "stropy", "podhľady"] },
    { slug: "omietky", name: "Omietky", keywords: ["vnútorné omietky", "vonkajšie omietky", "štuky"] },
    { slug: "stierky", name: "Stierky", keywords: ["stierková omietka", "jemná stierka", "štuková stierka"] },
    { slug: "podlahy", name: "Podlahy", keywords: ["betónová podlaha", "anhydrit", "podlahové kúrenie"] },
    { slug: "obklady", name: "Obklady a dlažby", keywords: ["keramický obklad", "kúpeľňa", "kuchyňa"] },
    { slug: "malovanie", name: "Maľovanie", keywords: ["maľovanie stien", "natieranie", "nátery"] },
    { slug: "tapetovanie", name: "Tapetovanie", keywords: ["tapety", "fototapety", "vliesové tapety"] },
    { slug: "podlahove-kurenie", name: "Podlahové kúrenie", keywords: ["teplovodné", "elektrické", "podlahovka"] },
    { slug: "potery", name: "Potery", keywords: ["cementový poter", "anhydrit", "samonivelačná stierka"] }
  ],
  instalcie: [
    { slug: "elektroinstalácie", name: "Elektroinštalácie", keywords: ["rozvody", "zapojenie", "elektromer"] },
    { slug: "vodoinstalácie", name: "Vodoinštalácie", keywords: ["rozvody vody", "kanalizácia", "odpad"] },
    { slug: "kurenie", name: "Kúrenie", keywords: ["radiátory", "podlahové kúrenie", "kotol"] },
    { slug: "plyn", name: "Plynové inštalácie", keywords: ["plynový kotol", "prípojka plynu"] },
    { slug: "klimatizacia", name: "Klimatizácia", keywords: ["chladenie", "split", "multisplit"] },
    { slug: "rekuperacia", name: "Rekuperácia", keywords: ["vetranie", "vzduchotechnika", "rekuperačná jednotka"] },
    { slug: "tepelne-cerpadla", name: "Tepelné čerpadlá", keywords: ["TČ", "vzduch-voda", "zem-voda"] },
    { slug: "solarne-panely", name: "Solárne panely", keywords: ["fotovoltika", "FVE", "solárna elektráreň"] },
    { slug: "bleskozvody", name: "Bleskozvody", keywords: ["ochrana pred bleskom", "uzemnenie"] }
  ],
  exterier: [
    { slug: "okna-dvere", name: "Okná a dvere", keywords: ["plastové okná", "vchodové dvere", "garážová brána"] },
    { slug: "fasada", name: "Fasády", keywords: ["fasádna omietka", "obklad fasády", "Baumit", "Weber"] },
    { slug: "ploty", name: "Ploty", keywords: ["betónové ploty", "pletivo", "oplotenie"] },
    { slug: "brany", name: "Brány a bránky", keywords: ["posuvná brána", "krídlová brána", "automatická brána"] },
    { slug: "terasy", name: "Terasy", keywords: ["drevená terasa", "WPC terasa", "pergola"] },
    { slug: "pergoly", name: "Pergoly", keywords: ["drevená pergola", "hliníková pergola", "bioklimatická"] },
    { slug: "garaze", name: "Garáže", keywords: ["murovaná garáž", "prístrešok", "carport"] },
    { slug: "altanky", name: "Altánky", keywords: ["záhradný altánok", "drevený altánok"] },
    { slug: "oporne-mury", name: "Oporné múry", keywords: ["gabiony", "betónový múr", "spevnenie svahu"] },
    { slug: "schody", name: "Vonkajšie schody", keywords: ["betónové schody", "kamenné schody"] },
    { slug: "pristuopove-cesty", name: "Prístupové cesty", keywords: ["príjazdová cesta", "chodník", "parkovisko"] }
  ],
  specialne: [
    { slug: "pivnice", name: "Pivnice", keywords: ["vínna pivnica", "suterén", "podzemný priestor"] },
    { slug: "studne", name: "Studne", keywords: ["vŕtaná studňa", "kopaná studňa", "čerpadlo"] },
    { slug: "septiky", name: "Septiky a ČOV", keywords: ["žumpa", "čistička odpadových vôd", "kanalizácia"] },
    { slug: "drevodomy", name: "Drevodomy", keywords: ["drevená stavba", "zrubový dom", "montovaný dom"] },
    { slug: "pasivne-domy", name: "Pasívne domy", keywords: ["nízkoenergetický dom", "A0", "energetická trieda"] },
    { slug: "smart-dom", name: "Smart dom", keywords: ["inteligentný dom", "automatizácia", "IoT"] },
    { slug: "hydroizolacie", name: "Hydroizolácie", keywords: ["izolácia proti vode", "spodná voda", "vlhkosť"] },
    { slug: "sanacia", name: "Sanácia budov", keywords: ["odvlhčenie", "injektáž", "sanácia základov"] }
  ]
};

// ============================================
// MATERIALS - Extended (100+ materials)
// ============================================
export const materials = {
  muriva: [
    "Porotherm", "Porotherm 44 EKO+", "Porotherm 38 T Profi", "Porotherm 30 Profi",
    "Ytong", "Ytong Lambda", "Ytong Theta+", "Ytong P2-500",
    "Heluz", "Heluz Family", "Heluz Plus", "Heluz STI",
    "Wienerberger", "Tehla plná pálená", "Betónové tvárnice",
    "Vápenno-pieskové tehly", "Keramické tvárnice", "KM Beta", "Siporex"
  ],
  izolacie: [
    "Polystyrén EPS 70F", "Polystyrén EPS 100F", "Polystyrén EPS 150S", "Polystyrén EPS 200S",
    "Polystyrén XPS", "Styrodur", "Austrotherm", "Isover EPS",
    "Minerálna vata", "Rockwool", "Isover", "Knauf Insulation",
    "Kamenná vata", "Sklená vata", "PIR dosky", "PUR pena",
    "Celulóza", "Drevovláknité dosky", "Konope", "Ovčia vlna",
    "Penové sklo", "Multipor", "Aerogel", "Vakuová izolácia"
  ],
  strecha: [
    "Betónová škridla Bramac", "Bramac Classic", "Bramac Montero", "Bramac Tegalit",
    "Keramická škridla Tondach", "Tondach Figaro", "Tondach Stodo",
    "Plechová krytina Lindab", "Ruukki", "Satjam", "Blachotrapez",
    "Trapézový plech", "Falcovaná krytina", "Click panel",
    "Asfaltové šindle IKO", "Tegola", "CertainTeed",
    "EPDM fólia", "PVC fólia", "TPO fólia", "Asfaltové pásy"
  ],
  fasada: [
    "Silikónová omietka Baumit", "Baumit Silikon Top", "Baumit Granopor",
    "Silikátová omietka", "Akrylátová omietka", "Minerálna omietka",
    "Weber", "Weber.pas", "Ceresit CT", "Caparol", "Sto",
    "Fasádny obklad", "Kamenný obklad", "Drevený obklad", "HPL obklad",
    "Tehličkový obklad", "Obkladové pásky", "Fasádne dosky Cembrit"
  ],
  podlahy: [
    "Betón C20/25", "Betón C25/30", "Drátkobetón", "Liaty asfalt",
    "Anhydrit", "Cementový poter", "Suchý poter Knauf",
    "Samonivelačná stierka", "Weber.floor", "Mapei Ultraplan",
    "Systém Rehau", "Systém Uponor", "Elektrické podlahovky Fenix",
    "Hydroizolácia Fatrafol", "Parozábrana", "PE fólia", "Kročajová izolácia"
  ],
  dlazba: [
    "Zámková dlažba Holland", "Zámková dlažba Vlnka", "Zámková dlažba Kocka",
    "Zámková dlažba Tetra", "Zámková dlažba Parketa", "Best dlažba",
    "Presbeton", "Semmelrock", "CS Beton", "Diton",
    "Betónová dlažba", "Vymývaná dlažba", "Štiepaná dlažba",
    "Prírodný kameň", "Žula", "Travertín", "Bridlica", "Pieskovec",
    "Štrk", "Mlat", "Zatrávňovacia dlažba"
  ],
  sadrokarton: [
    "Knauf SDK", "Knauf White", "Knauf Green", "Knauf Blue", "Knauf Diamant",
    "Rigips", "Rigips RB", "Rigips RF", "Rigips Activ Air",
    "Fermacell", "Fermacell Greenline",
    "CD profily", "UD profily", "CW profily", "UW profily",
    "Knauf Uniflott", "Knauf Fugenfuller", "Rigips Rimano"
  ],
  oknaAdvere: [
    "Plastové okná Veka", "Veka Softline", "Veka Artline", "Veka Perfectline",
    "Rehau okná", "Rehau Geneo", "Rehau Synego",
    "Salamander okná", "Schüco", "KBE", "Aluplast",
    "Hliníkové okná", "Drevené okná", "Drevo-hliníkové okná",
    "Vchodové dvere Hörmann", "Adlo", "Next", "Slovaktual"
  ]
};

// ============================================
// HELPER FUNCTIONS
// ============================================

// Get all locations flat
export const getAllLocations = () => {
  const allLocations = [];
  Object.values(locations).forEach(region => {
    if (region.districts) {
      region.districts.forEach(d => allLocations.push({ name: d, region: region.name }));
    }
    if (region.cities) {
      region.cities.forEach(c => allLocations.push({ name: c, region: region.name }));
    }
  });
  return allLocations;
};

// Get all services flat
export const getAllServices = () => {
  return [
    ...services.hlavne,
    ...services.stavebne,
    ...services.strechy,
    ...services.interier,
    ...services.instalcie,
    ...services.exterier,
    ...services.specialne
  ];
};

// Generate SEO combinations
export const generateSEOLinks = () => {
  const links = [];
  const allLocs = getAllLocations();
  const allSvcs = getAllServices();
  
  allLocs.forEach(loc => {
    allSvcs.forEach(svc => {
      links.push({
        title: `${svc.name} ${loc.name}`,
        slug: `${svc.slug}-${loc.name.toLowerCase().replace(/\s+/g, '-')}`,
        location: loc.name,
        service: svc.name,
        region: loc.region
      });
    });
  });
  
  return links;
};

// Statistics
export const seoStats = {
  get totalLocations() {
    return getAllLocations().length;
  },
  get totalServices() {
    return getAllServices().length;
  },
  get totalMaterials() {
    return Object.values(materials).reduce((acc, arr) => acc + arr.length, 0);
  },
  get totalCombinations() {
    return this.totalLocations * this.totalServices;
  }
};

export default { locations, services, materials, getAllLocations, getAllServices, generateSEOLinks, seoStats };
